export default __webpack_public_path__ + "static/media/offline_mode_icon.56bba109.svg";